export function sourceofWaterAddendum2027() {
return [   // Release 2026-10-02 11:21:10
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 22.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 253.985,
   left: 403.32,
   width: 169.20,
   height: 12.535
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 322.091,
   left: 79.44,
   width: 147.00,
   height: 13.189
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.96,
   left: 71.04,
   width: 501.36,
   height: 13.844
}
,
{
   page: 0,
   name: "well permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.2,
   left: 174.72,
   width: 271.80,
   height: 13.2
}
,
{
   page: 0,
   name: "Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 547.64,
   left: 139.32,
   width: 379.20,
   height: 13.189
}
,
{
   page: 0,
   name: "Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 568.44,
   left: 151.0,
   width: 368.52,
   height: 13.189
}
,
{
   page: 0,
   name: "Website", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 588.24,
   left: 151.0,
   width: 368.52,
   height: 13.189
}
,
{
   page: 0,
   name: "Phone No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 608.04,
   left: 162.4,
   width: 357.12,
   height: 13.189
}
,
{
   page: 0,
   name: "Checkbox Source of Water is a well", 
   isText: false,
   type: "checkbox",
   top: 457.529,
   left: 50.4002,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Well permit attached", 
   isText: false,
   type: "checkbox",
   top: 487.639,
   left: 498.766,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Well permit is not attached", 
   isText: false,
   type: "checkbox",
   top: 488.293,
   left: 523.639,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Water provider contact info", 
   isText: false,
   type: "checkbox",
   top: 531.493,
   left: 50.4002,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox No well or water", 
   isText: false,
   type: "checkbox",
   top: 640.148,
   left: 50.4002,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox No souce for potable water", 
   isText: false,
   type: "checkbox",
   top: 723.9305,
   left: 51.0548,
   width: 10.0800,
   height: 10.0800
}
,
{
   page: 0,
   name: "Source of water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 666.985,
   left: 51.7093,
   width: 526.3657,
   height: 56.0362
}
] }
